import { Slider } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div``;

export const CustomSlider = styled(Slider)`
	& .MuiSlider-rail {
		color: #e8e8e8;
	}

	& .MuiSlider-track {
		color: ${({ theme }) => theme.colors.primary.medium};
	}

	& .MuiSlider-thumb {
		color: ${({ theme }) => theme.colors.primary.medium};

		&:hover {
			box-shadow: none;
		}
	}

	& span.Mui-focusVisible {
		box-shadow: none;
	}
`;

export const Label = styled.div`
	margin-bottom: 12px;
	font-weight: 700;
	color: ${({ theme }) => theme.colors.primary.medium};
	font-size: 18px;
`;
